import {
  IMarketArticlesBasePayload,
  IMarketArticlesCollectionFilters, IMarketArticlesFilterPayload,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';

export const initialArticlesFilterState: IMarketArticlesFilterPayload = {
  dateFrom: null,
  dateTo: null,
  includedSectorIds: [],
  includedSubsectorIds: [],
  includedIndustryIds: [],
  includedSubindustryIds: [],
  includedIssuerIds: [],
  includedParentIds: [],
  includedProductIds: [],
  includedRegionIds: [],
  includedCountryIds: [],
  includedDealIds: [],
  includedMarketIds: [],
  includedSegmentIds: [],
};

export const initialArticlesBasePayloadState: IMarketArticlesBasePayload = {
  filter: initialArticlesFilterState,
  isExtended: false,
};

export const initialArticlesCollectionFiltersState: IMarketArticlesCollectionFilters = {
  search: '',
  sortBy: 'publishedAt',
  sortOrder: 'desc',
  page: 1,
  perPage: 25,
};

export const initialArticleData = {
  collection: [],
  totalCount: 0,
  payload: initialArticlesBasePayloadState,
  collectionFilters: initialArticlesCollectionFiltersState,
};
